module.exports = __webpack_public_path__ + "img/3tg-e100-440.prt.78aa574a.jpg";